import React, { useState } from 'react';
import ResearchCardGrid from '../ResearchCardGrid';
import Footer from '../Footer';
import Content from '../Content';
import './Projects.css';
import { Link } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import useProjects from '../../hooks/useProjects';

const THEME_SLUGS = [
  'hurricanes_and_extreme_weather',
  'city_research_colab',
  'ai_ml_digital_twin_efforts',
  'international_partnerships',
];

function Projects() {
  const [activeTheme, setActiveTheme] = useState(0);
  const { category } = useParams();
  const navigate = useNavigate();
  
  // Use the custom hook to fetch projects
  const { projects, loading, error } = useProjects(category);

  // Category-specific images
  const categoryImages = {
    'hurricanes_and_extreme_weather': '/images/hurricane1.png',
    'city_research_colab': '/images/city_research.png',
    'ai_ml_digital_twin_efforts': '/images/AI_ML_cover.png',
    'international_partnerships': '/images/international_partnership.png',
  };

  const categoryLabels = {
    'hurricanes_and_extreme_weather': 'Heat, Hurricanes and Extreme Weather',
    'city_research_colab': 'City Research + CoLab',
    'ai_ml_digital_twin_efforts': 'AI/ML Digital Twin Efforts',
    'international_partnerships': 'International Partnerships',
  };


  // Handle loading and error states
  if (loading) {
    return (
      <>
        <div className="projects-page">
          <div className="main-content-section">
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Loading projects...</p>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <div className="projects-page">
          <div className="main-content-section">
            <div className="error-container">
              <p className="error-message">Failed to load projects: {error.message}</p>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const handleCategoryClick = (category) => {
    // Navigate to the category-specific route
    navigate(`/projects/${category}`);
  };


  return (
    <>
      <div className="projects-page">
        <div className="header-banner">
          <div className="wall-container">
            <video className="bg-video" autoPlay muted loop playsInline>
              <source src={process.env.PUBLIC_URL + '/videos/drone-video.mp4'} />
            </video>
          </div>
          <h1>Projects</h1>
        </div>


        {!category ? (
          <div className="main-content-section">
            {/* Research themes as an index with a preview panel, matching the
                featured-projects section on the home page. */}
            <section className="projects-block projects-block--themes u-spread">
              <h2 className="section-title u-spread-label">Research Themes</h2>

              <div className="theme-index">
                <div className="u-index">
                  {THEME_SLUGS.map((categorySlug, index) => (
                    <div
                      key={categorySlug}
                      className="category-box u-index-row"
                      role="link"
                      tabIndex={0}
                      onClick={() => handleCategoryClick(categorySlug)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          handleCategoryClick(categorySlug);
                        }
                      }}
                      onMouseEnter={() => setActiveTheme(index)}
                      onFocus={() => setActiveTheme(index)}
                      onMouseLeave={() => setActiveTheme(0)}
                      onBlur={() => setActiveTheme(0)}
                    >
                      <span className="u-index-row-body">
                        <h3 className="u-index-title">{categoryLabels[categorySlug]}</h3>
                      </span>
                      <span className="u-index-arrow" aria-hidden="true">&rarr;</span>
                    </div>
                  ))}
                </div>

                <div className="u-preview" aria-hidden="true">
                  {THEME_SLUGS.map((categorySlug, index) => (
                    <span
                      key={categorySlug}
                      className={`u-preview-img ${activeTheme === index ? 'is-active' : ''}`}
                      style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL + categoryImages[categorySlug]})`,
                      }}
                    />
                  ))}
                </div>
              </div>
            </section>

            <section className="projects-block u-spread">
              <h2 className="section-title u-spread-label">Project Status</h2>

              <div className="u-index status-boxes">
                <div
                  className="status-box ongoing-projects u-index-row"
                  role="link"
                  tabIndex={0}
                  onClick={() => navigate('/ongoing-projects-list')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      navigate('/ongoing-projects-list');
                    }
                  }}
                >
                  <span className="status-overlay u-index-row-body">
                    <h3 className="u-index-title">Ongoing Projects</h3>
                    <p className="u-index-sub">View all current research projects</p>
                  </span>
                  <span className="u-index-arrow" aria-hidden="true">&rarr;</span>
                </div>
                <div
                  className="status-box completed-projects u-index-row"
                  role="link"
                  tabIndex={0}
                  onClick={() => navigate('/recently-completed-projects')}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      navigate('/recently-completed-projects');
                    }
                  }}
                >
                  <span className="status-overlay u-index-row-body">
                    <h3 className="u-index-title">Recently Completed Projects</h3>
                    <p className="u-index-sub">Explore our latest research outcomes</p>
                  </span>
                  <span className="u-index-arrow" aria-hidden="true">&rarr;</span>
                </div>
              </div>
            </section>
          </div>
        ) : (
          <div className="cardsgrid">
          <ResearchCardGrid cards={projects} />
        </div>
        )}
      </div>
    {/* <div style={{background:"#f7f7f7"}}>
    <div className="header-banner">
    <div className="wall-container">
        <video className="bg-video" autoPlay muted loop  playsInline>
          <source src={process.env.PUBLIC_URL + '/videos/drone-video.mp4'} />
        </video>
        </div>
         <h1>Projects</h1>
    </div>
      <div className="cardsgrid">
        <ResearchCardGrid cards={projects} />
      </div>
      </div> */}

       {/* 
    This is a multi-line comment.
    <p>You can comment out elements like this, too.</p>
  

      <div className="projects-page">
        {projects.map((project, index) => (
          <div key={index}>
            <Content
              title={project.title}
              pictureSrc={project.pictureSrc}
              content={project.longContent}
              targetSection={project.targetSection}
            />
            <Link to={`/content/${project.targetSection}`}>Read More</Link>
          </div>
        ))}
      </div>
      */}

      <Footer />
    </>
  );
}

export default Projects;
